import { simpleCreateMutation } from '$lib/utils/simpleQueryMutations';
import type { BrandDetailsData, BrandsParameters } from '@cf/api-v2-types';
import { ApiBrand } from '@cf/api-v2-types';

export const useBrandReadQuery = () => {
	return simpleCreateMutation(async (data: BrandsParameters): Promise<BrandDetailsData> => {
		const apiBrand = new ApiBrand('/proxy');
		const queryData = {
			...data,
			order: data.order || '',
			field: data.field || ''
		};
		const result = await apiBrand.readData(queryData);
		return result;
	});
};
export const useBrandReadIdQuery = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.getById(data);
		return result;
	});
};

export const useBrandReadListQuery = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.readList(data);
		return result;
	});
};

export const useBrandGetAllQuery = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.getAll(data);
		return result;
	});
};

export const useBrandCloneMutation = () => {
	return simpleCreateMutation(async (data: FormData) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.clone(data);
		return result;
	});
};
export const useBrandReadTopListQuery = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.readTopList(data);
		return result;
	});
};

export const useBrandCreateMutation = () => {
	return simpleCreateMutation(async (data: FormData) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.create(data);
		return result;
	});
};

export const useBrandUpdateMutation = () => {
	return simpleCreateMutation(async (data: { data: FormData; id: string; }) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.update(data);
		return result;
	});
};

export const useDocDeleteMutation = () => {
	return simpleCreateMutation(async (id: string) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.deleteDoc(id);
		return result;
	});
};

export const useBrandUpdateStatusMutation = () => {
	return simpleCreateMutation(async (data: { data: { active: boolean; }; id: string; }) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = (await apiBrand.updateStatus(data)) as {
			brand: [];
			statusCode: number;
			success: boolean;
		};
		return result;
	});
};

export const useBrandDeleteMutation = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');
		const result = await apiBrand.delete(data);
		return result;
	});
};

export const useBrandMarketplaceMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.marketplace(data);
		return result;
	});
};

export const useBrandProviderMutation = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.provider(data);
		return result;
	});
};

export const useBrandMarketplaceEnabledMutation = () => {
	return simpleCreateMutation(
		async (data: {
			brand_id: string;
			marketplace_ids: string[];
			is_toggle: boolean;
			is_enable_all?: boolean;
		}) => {
			const apiBrand = new ApiBrand('/proxy');

			const result = await apiBrand.marketplaceEnabled({
				brand_id: data.brand_id,
				marketplace_ids: data.marketplace_ids,
				is_toggle: data.is_toggle,
				is_enable_all: data.is_enable_all
			});
			return result;
		}
	);
};
export const useSellersBrandsMutation = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrands = new ApiBrand('/proxy');
		const result = await apiBrands.getBrandsProvider(data);
		return result;
	});
};
export const useBrandProviderCreateMutation = () => {
	return simpleCreateMutation(async (data: unknown) => {
		const apiBrand = new ApiBrand('/proxy');

		const result = await apiBrand.createProvider(data);
		return result;
	});
};
